import * as React from "react"
import { type ResponsiveComponents } from "@digits-shared/components/Responsive/responsiveComponent"
import { isMobile, isTablet } from "@digits-shared/helpers/devicesHelper"

/**
 * Renders the desktop or mobile component based on the device type that matches the path
 *
 *  <Route
 *    path="/foo"
 *    render={() => (
 *       <ResponsiveRoute desktop={Home} mobile={MobileHome} />
 *    )}
 *  />
 */
export const ResponsiveRoute: React.FC<ResponsiveComponents> = ({ mobile, desktop, tablet }) => {
  if (isTablet && tablet) {
    const Component = tablet
    return <Component />
  }

  if (isMobile) {
    const Component = mobile
    return <Component />
  }

  const Component = desktop
  return <Component />
}
